import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useLocation, useNavigate, useParams} from "react-router";
import type {DatabagRouteMatch} from "../../routing/catRoutes";
import {useStores} from "../../stores";
import type {RouteWrapperProps} from "./RouteWrapperProps";
import {SingleDatabagWrapped} from "./base/SingleDatabagWrapped";
import {generateDashboardPath} from "../../routing/routing.utils.ts";

export const AutoSelectWrapper: React.FC<RouteWrapperProps> = observer(({children, state}) => {
    const {
        bagStore,
        rootAppStore,
        bagLoadingStore,
        taxonomySuggestorStore,
    } = useStores();
    const params = useParams<DatabagRouteMatch & {revisionHackParam: string}>();
    const location = useLocation();
    const navigate = useNavigate();
    const hasCurrentBag = !!bagStore.bag;

    useEffect(() => {
        rootAppStore.setApp(state)
        bagStore.getAllBags();
    }, [])

    useEffect(() => {
        taxonomySuggestorStore.setSelectedNodeLabel(undefined)
        taxonomySuggestorStore.setSelectedNodeValues(undefined)

        if (!hasCurrentBag && Array.isArray(bagStore.userBagChoices) && bagStore.userBagChoices.length > 0) {
            const bagToSet = bagStore.userBagChoices[0];

            const newParams = {...params, id: String(bagToSet.id)};
            Promise.resolve(bagLoadingStore.initBagAsync(location, navigate, newParams)).then(newBagId => {
                if (newBagId) {
                    navigate(generateDashboardPath(location, newParams, rootAppStore.app), {replace: true});
                }
            })
        }
    }, [hasCurrentBag, bagStore.userBagChoices])

    return <SingleDatabagWrapped state={state}>{children}</SingleDatabagWrapped>;
});
